import { FormLabel } from "@chakra-ui/react";
import React from "react";

const CommonLabel = ({
  children,
  ...props
}: React.ComponentProps<typeof FormLabel>) => (
  <FormLabel fontSize="16px" textColor="#2F2F34" fontWeight={600} {...props}>
    {children}
  </FormLabel>
);

export default CommonLabel;
